
<template>
    <ListDialog ref="SlipJournalItemDialog" :title="$parent.formatTitle('会計仕訳一覧表')"  :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
        <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SlipJournalItemReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【会計仕訳】のデータを選択でき、初期値は×で消してから変更が可能です。" />
        <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
              <AutoComplete title="勘定科目" :value.sync="account" :editor="editor" query="AccountMasterQuery" tooltip="ここで勘定科目を選択をすると、選択した勘定科目だけのデータを出力する事ができます。選択しない場合はすべての勘定科目のデータが出力できます。" path="/master/Account"/>
        <Calendar title="算入日(From)" :editor="editor" :value.sync="startDate" :deletable="false" :required="true"  :autoEntry="true" :dateFlag.sync="startDateFlag"  tooltip="データを帳票に出力をする算入日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	    <Calendar title="算入日(To)" :editor="editor" :value.sync="endDate" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="endDateFlag" tooltip="データを帳票に出力をする算入日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>              
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>         
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSlipJournalItem extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public segment: Common.Segment = null;
  public account: Common.Account = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.SlipJournalItemReportTemplateQuery = new Common.SlipJournalItemReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.startDate = new Date().getCalendarDate();
    this.startDate.setDate(1);
    this.endDate = new Date().getCalendarDate();
    this.endDate = new Date(this.endDate.getFullYear(),this.endDate.getMonth() + 1, 0);
    
    (this.$refs.SlipJournalItemDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SlipJournalItemReportQuery = new Common.SlipJournalItemReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.account = this.account;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
</script>
